import React from 'react';
import { T } from '@testout/labsim-ui-atomics';
export default ({ title, body }) => {
    return (React.createElement(T.Dialog, { automationId: 'errorDlg' },
        React.createElement(T.Dialog.Header, null,
            React.createElement(T.Dialog.Title, null, title)),
        React.createElement(T.Dialog.Body, null, body)));
};
//# sourceMappingURL=ErrorModal.js.map